<template lang="pug">
van-nav-bar(:title='modelFileName' fixed :left-arrow="hasLeft" @click-left='onClickLeft' )
  template(#right)
    span.jylabel(@click='closeDwg') 3D
</template>

<script>
import { mongeApp, mongeMutations } from "@/CommonDP/mongeView/store/mongeStore";
import mongeApiMlib from "@/CommonDP/mongeView/mongeApiMlib";

export default {
  data () {
    return {
      groupPics: []
    };
  },
  computed: {
    isLoginFree() {
      return this.$route.query.isLoginFree || "";
    },
    hasLeft() {
      return !this.$route.query.i;
    },
    modelFileName() {
      if (this.modelInfoData.fileObj) {
        return this.modelInfoData.fileObj.map(e => e.folderName).join();
      }
      return this.modelInfoData.fileName || "未命名";
    },
    modelInfoData() {
      return JSON.parse(mongeApp.model.fileInfo);
    }
  },
  methods: {
    // 头部按钮返回
    onClickLeft() {
      const data = { source: "back" };
      let { isH5 } = this.$route.query || {};
      mongeApiMlib.rebackLastPage(this.isLoginFree || isH5, data);
    },
    async closeDwg() {
      mongeMutations.setHasDwg(false);
      mongeMutations.setModelPageFileName();
      await this.$nextTick();
      mongeApiMlib.resize();
    }
  }
};
</script>

<style lang="scss" scoped>
.van-nav-bar__content {
  height: 88upx;
}
.jylabel{
  margin-right: 8px;
  color: var(--theme-color);
  font-size: 16px;
  font-weight: 800;
}
</style>
